import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { cloneDeep, findIndex, orderBy } from 'lodash';

import { AppSettingsService } from '../../../../../app-settings.service';
import { Enums } from '../../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-sync',
  templateUrl: './tickets-sync.component.html',
  styleUrls: ['./tickets-sync.component.scss'],
  standalone: false,
})
export class TicketsSyncComponent implements OnInit {
  public loading: boolean;
  public typesBKSearchText: string;
  public isShowChangedNameTickets: boolean;
  public bkTicketsTypes: any[];
  public bkTicketsTypesDefault: any[];
  public typesHDSearchText: string;
  public isShowMissingTickets: boolean;
  public hdTicketsTypes: any[];
  public hdTicketsTypesDefault: any[];
  public missingPlaceholder = 'Название типа не совпадает или тип отсутствует в BK';
  public isErrorSave = false;
  public Enums = Enums;

  constructor(private appSettingsService: AppSettingsService) {}

  ngOnInit() {
    this.getTicketsTypes();
  }

  private getTicketsTypes(): any {
    this.loading = true;
    this.appSettingsService
      .getTicketsTypes()
      .then(
        (response) => {
          this.bkTicketsTypes = response[0].data;
          this.hdTicketsTypes = response[1].data;
          this.bkTicketsTypesDefault = cloneDeep(this.bkTicketsTypes);
          this.hdTicketsTypesDefault = cloneDeep(this.hdTicketsTypes);
        },
        (error) => {
          this.bkTicketsTypes = null;
          this.hdTicketsTypes = null;
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }

  public checkShowAdd(type): boolean {
    const index = findIndex(this.bkTicketsTypes, (t) => t.id === type.id && t.name === type.name);

    return index === -1;
  }

  public addTypeToBK(type, index): void {
    const types = this.bkTicketsTypes;
    const indexBKType = findIndex(types, (t) => t.id === type.id);

    if (indexBKType > -1) {
      types[indexBKType] = Object.assign(types[indexBKType], type);
    } else {
      types.push(cloneDeep(type));
    }

    this.bkTicketsTypes = orderBy(types, ['id'], ['asc']);
    // this.hdTicketsTypes.splice(index, 1);
  }

  public removeTypeToBK(type, index): void {
    const types = this.hdTicketsTypes;
    const indexBKType = findIndex(this.bkTicketsTypes, (t) => t.id === type.id);
    let arr = null;
    // types.push(cloneDeep(type));

    this.hdTicketsTypes = orderBy(types, ['id'], ['asc']);

    console.log(indexBKType);
    if (indexBKType > -1) {
      this.bkTicketsTypes.splice(indexBKType, 1);
      arr = cloneDeep(this.bkTicketsTypes);
      this.bkTicketsTypes = arr;
    }
  }

  public checkNotMatchName(type): boolean {
    const index = findIndex(this.hdTicketsTypes, (t) => t.id === type.id && t.name !== type.name);

    return index > -1;
  }

  public checkMissingBK(type): boolean {
    const index = findIndex(this.bkTicketsTypesDefault, (t) => t.id === type.id);
    const index2 = findIndex(this.bkTicketsTypesDefault, (t) => t.id === type.id && t.name !== type.name);

    return index === -1 || index2 >= 0;
  }

  public onSaveTypes(): void {
    this.loading = true;
    this.appSettingsService
      .saveTicketsTypes({
        types_ids: this.bkTicketsTypes.map((type) => type.id),
      })
      .subscribe(
        (response) => {
          this.isErrorSave = false;
          this.isShowMissingTickets = false;
          this.isShowChangedNameTickets = false;
          this.typesBKSearchText = null;
          this.typesHDSearchText = null;
          this.bkTicketsTypes = null;
          this.hdTicketsTypes = null;
          this.bkTicketsTypesDefault = null;
          this.hdTicketsTypesDefault = null;
          this.getTicketsTypes();
        },
        (error) => {
          this.isErrorSave = true;
          this.loading = false;
        }
      );
  }

  public resetTypes(): void {
    this.isShowMissingTickets = false;
    this.isShowChangedNameTickets = false;
    this.typesBKSearchText = null;
    this.typesHDSearchText = null;
    this.bkTicketsTypes = cloneDeep(this.bkTicketsTypesDefault);
    this.hdTicketsTypes = cloneDeep(this.hdTicketsTypesDefault);
  }
}
